export default "__VITE_ASSET__C6W12hvo__"